
<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="出入库流水"
      :page="page"
      :show-query="true"
      :get-data-func="api.mouldStockList"
      v-if="trendShow"
      urlHash="business/stock/completemoulds"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

   
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/ba/mould').default,
      trendShow: true,
      tableData: [],
    };
  },
  methods: {
   
  //  getSummary(param) {
      
  //     const { columns, data } = param;
  //     let labels = ["入库数量","入库单价","入库金额","出库数量","出库单价","出库金额"];

  //     const sums = [];
  //     columns.forEach((column, index) => {
  //       if (index === 0) {
  //         sums[index] = "合计";
  //         return;
  //       }
  //       const values = data.map((item) => {
  //         if (labels.includes(column.label)) {
  //           return Number(item[column.property]);
  //         }
  //       });

  //       if (!values.every((value) => isNaN(value))) {
  //         sums[index] = values.reduce((prev, curr) => {
  //           const value = Number(curr);
  //           if (!isNaN(value)) {
  //             return prev + curr;
  //           } else {
  //             return prev;
  //           }
  //         }, 0);
  //         sums[index];
  //       } else {
  //         sums[index] = "";
  //       }
  //     });

  //     return sums;
  //   },
  }
};
</script>

